import React from 'react';

type SkeletonType = 'stats' | 'list' | 'card';

interface LoadingSkeletonProps {
  type?: SkeletonType;
  count?: number;
}

const renderStatsSkeleton = () => (
  <div className="grid grid-cols-1 gap-4 md:grid-cols-4">
    {Array.from({ length: 4 }).map((_, index) => (
      <div key={index} className="rounded-lg border border-gray-200 p-4 shadow-sm">
        <div className="mb-2 h-4 w-1/3 rounded bg-gray-200" />
        <div className="h-8 w-2/3 rounded bg-gray-200" />
      </div>
    ))}
  </div>
);

const renderListSkeleton = (count: number) => (
  <div className="space-y-3">
    {Array.from({ length: count }).map((_, index) => (
      <div key={index} className="rounded-lg border border-gray-100 p-4 shadow-sm">
        <div className="mb-2 h-4 w-1/2 rounded bg-gray-200" />
        <div className="h-4 w-1/3 rounded bg-gray-200" />
      </div>
    ))}
  </div>
);

const renderCardSkeleton = (count: number) => (
  <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
    {Array.from({ length: count }).map((_, index) => (
      <div key={index} className="rounded-xl border border-gray-100 p-6 shadow">
        <div className="mb-4 h-5 w-1/2 rounded bg-gray-200" />
        <div className="space-y-2">
          <div className="h-4 w-full rounded bg-gray-200" />
          <div className="h-4 w-5/6 rounded bg-gray-200" />
          <div className="h-4 w-2/3 rounded bg-gray-200" />
        </div>
      </div>
    ))}
  </div>
);

export const LoadingSkeleton: React.FC<LoadingSkeletonProps> = ({ type = 'list', count = 3 }) => {
  return (
    <div className="animate-pulse space-y-4">
      {type === 'stats' && renderStatsSkeleton()}
      {type === 'list' && renderListSkeleton(count)}
      {type === 'card' && renderCardSkeleton(count)}
    </div>
  );
};
